<template>
  <div v-if="selectedBot && selectedBot.packages">
    <div class="mb-5" style="text-align: center;">
      <v-layout
        wrap
        v-if="currentLang != 'la'"
        style="display: inline-flex;"
        :style="this.$vuetify.breakpoint.xs ? 'white:100%' : 'width: 100%'"
      >
        <v-flex sm6 xs12 lg4 class="px-2 py-3">
          <div class="card-package-yellow z-border-red" style="height: 100%;">
            <img src="/static/img/assets/icon/z-13.png" alt="" />
            <h1 class="mb-0 black-color">Basic</h1>
            <!-- <div class="caption mb-2">(90 {{ $t('Days') }})</div> -->

            <br />
            <div style="display: inline-flex;" class="mb-2">
              <v-img
                src="https://zwiz.ai/web/public/img/socials/fb.png"
                alt=""
                style="width: 34px; margin-right: 15px;"
              />
            </div>
            <!-- <p class="price yellow-color">{{ $t('Price') }} 2,970 {{ $t('Baht') }}</p>
            <span class="discount yellow-color" style="content: ' '"></span>
            <p>990 {{ $t('Baht per month') }}</p> -->

            <h1 class="text-xs-center" style="height: 330px; font-size: 75px; font-weight: 500;">
              {{ $t('Free') }}
            </h1>

            <div class="text-xs-center mb-4" style="margin-top: 100px;">
              <!-- <div class="mb-3">
                <v-btn
                  style="width:100%; font-size:20px"
                  :href="'https://cms.zwiz.ai/' + currentLang"
                  dark
                  color="primary"
                  depressed
                >
                  <template>
                    {{ $t('Get StarteD') }}
                  </template>
                </v-btn>
              </div> -->
              <a @click="moreDetails = !moreDetails" style="font-weight: bold; font-size:16px">{{
                !moreDetails ? $t('More details') : $t('Hide details.')
              }}</a>
              <template v-if="moreDetails">
                <span class="mt-3">
                  <hr />
                  <div class="h4-text">{{ $t('Chat') }}</div>
                  <ul class="custom text-xs-left mt-3">
                    <li>
                      <a style="color: #000" href="https://tinyurl.com/3758bkbm" target="_blank"
                        >{{ $t('Support messaging with text/ Picture/ Carousel/ Video') }}
                      </a>
                    </li>
                    <li>
                      <a style="color: #000" href="https://tinyurl.com/3758bkbm" target="_blank">
                        {{ $t('Create conversations up to') }}
                        <strong style="color: black"> 10 {{ $t('topics') }}</strong></a
                      >
                    </li>
                    <li>
                      <a style="color: #000" href="https://tinyurl.com/3758bkbm" target="_blank">
                        {{ $t('1 topic can answer up to') }}
                        <strong style="color: black"> 2 {{ $t('bubbles') }}</strong>
                      </a>
                    </li>
                    <li>
                      <a style="color: #000" href="https://tinyurl.com/y5cnc2t8" target="_blank"
                        >{{ $t('Random answer') }}
                      </a>
                    </li>
                    <li class="disable-feature">{{ $t('Transfer data to another page') }}</li>
                    <li class="disable-feature">{{ $t('Create context messaging') }}</li>
                    <li class="disable-feature">{{ $t('Set up time to reply each topic.') }}</li>
                    <li class="disable-feature">
                      {{ $t('Same messaging set up to all platforms') }}
                    </li>
                    <li class="disable-feature">{{ $t('Bot practicing function') }}</li>
                    <li class="disable-feature">{{ $t('Reply a Sticker via LINE') }}</li>
                    <li class="disable-feature">{{ $t('Support LINE FLEX code via LINE') }}</li>
                    <li class="disable-feature">{{ $t('LINE Image Map') }}</li>
                    <li class="disable-feature">{{ $t('Follow up') }}</li>
                  </ul>
                  <div style="line-height: 0px;">&nbsp;</div>

                  <hr />

                  <div class="h4-text">{{ $t('Comment') }}</div>
                  <ul class="custom text-xs-left">
                    <li>
                      <a style="color: #000" href="https://tinyurl.com/yvz76f5s" target="_blank">
                        {{ $t('Create comments up to')
                        }}<strong style="color: black"> 2 {{ $t('topics') }}</strong>
                      </a>
                    </li>
                    <li>
                      <a style="color: #000" href="https://tinyurl.com/yvz76f5s" target="_blank"
                        >{{ $t('Comment to Inbox') }}
                      </a>
                    </li>
                    <li>
                      <a style="color: #000" href="https://tinyurl.com/55k48kvk" target="_blank"
                        >{{ $t('Random answer') }}
                      </a>
                    </li>

                    <li class="disable-feature">
                      {{
                        $t(
                          'Comment to Inbox with text/button/ picture/ carousel/ Video and customers order summary'
                        )
                      }}
                    </li>
                    <li class="disable-feature">{{ $t('Hiding Comments') }}</li>
                    <li class="disable-feature">{{ $t('Reply to a comment on posts') }}</li>
                    <li class="disable-feature">
                      {{ $t('Reply to a comment on selected posts (FB,IG)') }}
                    </li>
                    <li class="disable-feature">{{ $t('Set up time to answer each topic.') }}</li>
                    <li class="disable-feature">
                      {{ $t('Limit the number of replies to comments.') }}
                    </li>
                    <li class="disable-feature">{{ $t('Follow up') }}</li>
                  </ul>

                  <hr />

                  <div class="h4-text">{{ $t('Shop Service') }}</div>
                  <ul class="custom text-xs-left">
                    <li>
                      <a style="color: #000" href="https://tinyurl.com/mr3dr39k" target="_blank">
                        {{ $t('Add up to') }}
                        <strong style="color: black">5 {{ $t('products') }}</strong>
                      </a>
                    </li>
                    <li>
                      <a style="color: #000" href="https://tinyurl.com/mr3dr39k" target="_blank"
                        >{{ $t('Manage Stocks') }}
                      </a>
                    </li>
                    <li>
                      <a style="color: #000" href="https://tinyurl.com/mr3dr39k" target="_blank"
                        >{{ $t('Manage orders') }}
                      </a>
                    </li>
                    <li>
                      <a style="color: #000" href="https://tinyurl.com/mr3dr39k" target="_blank"
                        >{{ $t('Print the parcels cover sheet') }}
                      </a>
                    </li>
                    <li>
                      <a style="color: #000" href="https://tinyurl.com/2xa4wy8h" target="_blank"
                        >{{ $t('Automation Sales Summary') }}
                      </a>
                    </li>
                    <li>
                      <a style="color: #000" href="https://tinyurl.com/4trrbhje" target="_blank"
                        >{{ $t('In-Chat Payments') }}
                      </a>
                    </li>
                    <li class="disable-feature">{{ $t('Generate discount codes') }}</li>
                    <li class="disable-feature">{{ $t('Change shops theme color') }}</li>
                    <li class="disable-feature">{{ $t('Connect with Salepage') }}</li>
                    <li class="disable-feature">{{ $t('Wholesale system') }}</li>
                    <li class="disable-feature">{{ $t('Sales Report') }}</li>
                    <li class="disable-feature">{{ $t('Export data') }}</li>
                    <li class="disable-feature">{{ $t('Follow up') }}</li>
                  </ul>

                  <hr />
                  <div class="h4-text">{{ $t('Broadcast') }}</div>
                  <ul class="custom text-xs-left">
                    <li>
                      <a style="color: #000" href="https://tinyurl.com/yj354f7y" target="_blank"
                        >{{ $t('Send to customers who have interacted within 24 hours.') }}
                      </a>
                    </li>
                    <li>
                      <a style="color: #000" href="https://tinyurl.com/y27chwmw" target="_blank"
                        >{{ $t('Message Format broadcasts') }}
                      </a>
                    </li>
                    <li class="disable-feature">
                      {{
                        $t(
                          'Send to prior customer on certain topics (according to the terms of Facebook)'
                        )
                      }}
                    </li>
                    <li class="disable-feature">{{ $t('Broadcast time set up') }}</li>
                    <li class="disable-feature">{{ $t('Select custom audiences') }}</li>
                    <li class="disable-feature">
                      {{ $t('Reply up to 10 bubbles for FB/IG content and 5 bubbles for LINE') }}
                    </li>
                  </ul>
                  <div style="line-height: 35px;">&nbsp;</div>

                  <hr />
                  <div class="h4-text">{{ $t('Analytics') }}</div>
                  <ul class="custom text-xs-left">
                    <li>
                      <a style="color: #000" href="https://tinyurl.com/yhfh6fd7" target="_blank"
                        >{{ $t('Store data up to 3 months') }}
                      </a>
                    </li>
                    <li>
                      <a style="color: #000" href="https://tinyurl.com/yhfh6fd7" target="_blank"
                        >{{ $t('Facebook Inbox Overview') }}
                      </a>
                    </li>
                    <li>
                      <a style="color: #000" href="https://tinyurl.com/yhfh6fd7" target="_blank"
                        >{{ $t('Conversation/Comment Statistics') }}
                      </a>
                    </li>
                    <li>
                      <a style="color: #000" href="https://tinyurl.com/yhfh6fd7" target="_blank"
                        >{{ $t('User statistics') }}
                      </a>
                    </li>
                    <li class="disable-feature">{{ $t('Tag / status') }}</li>
                    <li class="disable-feature">
                      {{ $t('Automatically collect typed in customers email and number.') }}
                    </li>
                    <li class="disable-feature">{{ $t('Export file to Excel/CSV') }}</li>
                    <li class="disable-feature">{{ $t('Import prior customers') }}</li>
                    <li class="disable-feature">{{ $t('Custom Audience') }}</li>
                  </ul>

                  <hr />
                  <div class="h4-text">{{ $t('Shortcut') }}</div>
                  <ul class="custom text-xs-left">
                    <li class="disable-feature">{{ $t('Shortcut # for switching to admin') }}</li>
                    <li class="disable-feature">
                      {{ $t('Switching chatbot mode and admin mode') }}
                    </li>
                  </ul>

                  <hr />
                  <div class="h4-text">{{ $t('Notifications') }}</div>
                  <ul class="custom text-xs-left">
                    <li class="disable-feature">
                      {{
                        $t(
                          'Connecting with LINE Notify for specific topic or chatbots unanswered question.'
                        )
                      }}
                    </li>
                    <li class="disable-feature">
                      {{ $t('Connecting with LINE Notify for new orders/new payment activities.') }}
                    </li>
                  </ul>
                  <hr />
                  <div class="h4-text">{{ $t('All-in-one Chat') }}</div>
                  <ul class="custom text-xs-left">
                    <li class="disable-feature">
                      {{ $t('Integrate FB + LINE + IG in one place') }}
                    </li>
                    <li class="disable-feature">{{ $t('Open billing via chat') }}</li>
                    <li class="disable-feature">{{ $t('Quick message function') }}</li>
                    <li class="disable-feature">{{ $t('Send and receive files') }}</li>
                    <li class="disable-feature">{{ $t('Easily switching chatbot admin mode') }}</li>
                  </ul>
                  <hr />
                  <div class="h4-text">{{ $t('Salepage') }}</div>
                  <ul class="custom text-xs-left">
                    <li class="disable-feature">{{ $t('Connecting with Shop Service') }}</li>
                    <li class="disable-feature">{{ $t('Change Salepages theme color') }}</li>
                    <li class="disable-feature">{{ $t('Add up to 20 blocks') }}</li>
                    <li class="disable-feature">{{ $t('Link to Youtube video') }}</li>
                    <li class="disable-feature">
                      {{ $t('Provide connecting with Facebook Pixel code') }}
                    </li>
                    <li class="disable-feature">
                      {{ $t('Provide connecting with Google Tag Manager') }}
                    </li>
                    <li class="disable-feature">
                      {{ $t('Provide connecting with Google Analytics') }}
                    </li>
                    <li class="disable-feature">
                      {{ $t('Provide connecting with Tiktok Pixel') }}
                    </li>
                  </ul>
                  <hr />
                  <div class="h4-text">{{ $t('Beacon') }}</div>
                  <ul class="custom text-xs-left">
                    <li class="disable-feature">
                      {{
                        $t(
                          'This package is compatible with Beacon(a technology capable of sending messages by Bluetooth transmitters to the LINE customer app without any charge for Push Message)'
                        )
                      }}
                    </li>
                  </ul>
                  <hr />
                  <div class="h4-text">{{ $t('connect_zerva') }}</div>
                  <ul class="custom text-xs-left">
                    <li>
                      {{ $t('connecting_to_zerva') }}
                    </li>
                    <li class="disable-feature">
                      {{ $t('send_follow_up_message') }}
                    </li>
                  </ul>
                  <hr />
                  <div class="h4-text">{{ $t('messenger_ads_simulator_(json)') }}</div>
                  <ul class="custom text-xs-left">
                    <li>
                      <a style="color: #000" href="https://tinyurl.com/6jyeyub7" target="_blank">
                        {{ $t('messenger_ads_simulator_basic') }}
                      </a>
                    </li>
                  </ul>
                  <hr />
                  <div class="h4-text">{{ $t('verify_slip_title') }}</div>
                  <ul class="custom text-xs-left">
                    <li class="disable-feature">
                      {{ $t('verify_slip_1') }}
                    </li>
                    <li class="disable-feature">
                      {{ $t('verify_slip_2') }}
                    </li>
                  </ul>
                  <hr />
                  <div class="h4-text">{{ $t('connect_stocks') }}</div>
                  <ul class="custom text-xs-left">
                    <li class="disable-feature">
                      {{ $t('connect_stocks_1') }}
                    </li>
                    <li class="disable-feature">
                      {{ $t('connect_stocks_2') }}
                    </li>
                    <li class="disable-feature">
                      {{ $t('connect_stocks_3') }}
                    </li>
                    <li class="disable-feature">
                      {{ $t('connect_stocks_4') }}
                    </li>
                    <li class="disable-feature">
                      {{ $t('connect_stocks_5') }}
                    </li>
                    <li class="disable-feature">
                      {{ $t('connect_stocks_6') }}
                    </li>
                  </ul>
                  <hr />
                  <div class="h4-text">{{ $t('connect_shipping') }}</div>
                  <ul class="custom text-xs-left">
                    <li>
                      <a style="color: #000" href="https://tinyurl.com/taynws5p" target="_blank">
                        {{ $t('connect_shipping_1') }}
                      </a>
                    </li>
                    <li>
                      <a style="color: #000" href="https://tinyurl.com/2ft3hvjj" target="_blank">
                        {{ $t('connect_shipping_2') }}
                      </a>
                    </li>
                    <li>
                      <a style="color: #000" href="https://tinyurl.com/ykjuuny8" target="_blank">
                        {{ $t('connect_shipping_3') }}
                      </a>
                    </li>
                  </ul>
                  <div class="h4-text">{{ $t('redirect_url_tracking') }}</div>
                  <ul class="custom text-xs-left">
                    <li class="disable-feature">
                      {{ $t('redirect_url_tracking1') }}
                    </li>
                  </ul>

                  <h3 class="mt-2 mb-2" style="color: black">
                    {{ $t("Number of Admins depend on Facebook's Page Role") }}
                  </h3>

                  <a
                    @click="moreDetails = !moreDetails"
                    style="font-weight: bold; font-size:16px"
                    >{{ $t('Hide details.') }}</a
                  >
                </span>
              </template>
            </div>
          </div>
        </v-flex>
        <v-flex sm6 xs12 lg4 class="px-2 py-3">
          <div class="card-package-yellow z-border-red" style="height: 100%;">
            <img src="/static/img/assets/icon/z-14.png" alt="" />
            <h1 class="mb-0 black-color">{{ $t('Premium') }}</h1>
            <!-- <div class="caption mb-2">(90 {{ $t('Days') }})</div> -->

            <br />
            <div style="display: inline-flex;" class="mb-2">
              <v-img
                src="https://zwiz.ai/web/public/img/socials/fb.png"
                alt=""
                style="width: 34px; margin-right: 15px;"
              />
              <v-img
                src="https://zwiz.ai/web/public/img/socials/ig.jpeg"
                alt=""
                style="width: 34px; margin-right: 15px;"
              />
              <v-img
                src="https://zwiz.ai/web/public/img/socials/shop.png"
                alt=""
                style="width: 34px;"
              />
            </div>
            <!-- <p class="price yellow-color">{{ $t('Price') }} 2,970 {{ $t('Baht') }}</p>
            <span class="discount yellow-color" style="content: ' '"></span>
            <p>990 {{ $t('Baht per month') }}</p> -->

            <div class="feature-card no-animate border-primary h-100">
              <div
                class="feature-card-text kanit text-xs-left  h-100"
                style="justify-content: space-between;flex-direction: column;"
              >
                <div class="mt-auto text-xs-center ">
                  <div class="packageradio text-xs-left" style="margin-top: 21px; height: 285px;">
                    <template v-for="pack in list">
                      <div
                        style="cursor:pointer"
                        :key="pack.package"
                        class="px-3 py-2 mb-2 pack"
                        :class="{ active: pack.package == current.package }"
                        @click="selectPack(pack)"
                      >
                        <div class="d-inline-flex" style="font-size: 1.5rem;">
                          <div class="flex-shrink-1">
                            <i
                              class="fas"
                              :class="{
                                'fa-circle': pack.package != current.package,
                                'fa-check-circle': pack.package == current.package
                              }"
                              :style="{
                                color: pack.package != current.package ? '#eee' : 'white'
                              }"
                            ></i>
                          </div>
                          <div
                            class="pl-2 black-color"
                            :style="{
                              color: pack.package != current.package ? '' : 'white'
                            }"
                          >
                            <div class="h4 font-weight-light mb-0">
                              {{ currentLang === 'th' ? pack.text : pack.texten }}
                            </div>
                            <div
                              style="font-size: 16px;"
                              :style="{
                                color: pack.package != current.package ? 'grey' : 'white'
                              }"
                              v-if="pack.dec"
                            >
                              + {{ currentLang === 'th' ? pack.dec : pack.decen }}
                            </div>
                            <div v-if="pack.dec">
                              <a
                                style="font-size: 16px; cursor:pointer"
                                @click="dialogMoreDetail = true"
                                >{{ $t('more_details') }}</a
                              >
                            </div>
                          </div>
                        </div>
                      </div>
                    </template>

                    <div>&nbsp;</div>

                    <h2 style="font-size: 32px;" class="primary--text mb-2">
                      {{ current ? `${current.price}  ${$t('Baht')}` : '' }}
                    </h2>
                  </div>
                </div>
              </div>
            </div>

            <div class="text-xs-center mb-4" style="margin-top: 60px">
              <div class="mb-3">
                <!-- <premium-form
                  color="primary"
                  :params="current.package"
                  :type="'qrcode'"
                  :pid="current.pid"
                  :pack="current.name"
                >
                  <template v-slot="{ showDialog }">
                    <v-btn
                      style="width:100%; font-size:20px"
                      dark
                      color="primary"
                      depressed
                      @click="dialogPayment = true"
                    >
                      <template>
                        {{ $t('Buy Premium') }}
                      </template>
                    </v-btn>
                  </template>
                </premium-form> -->
                <v-btn
                  style="width:100%; font-size:20px"
                  dark
                  color="primary"
                  depressed
                  @click="handleClickPremium()"
                >
                  <template>
                    {{ $t('Buy Premium') }}
                  </template>
                </v-btn>
              </div>
              <a @click="moreDetails = !moreDetails" style="font-weight: bold; font-size:16px">
                {{ !moreDetails ? $t('More details') : $t('Hide details.') }}</a
              >
              <template v-if="moreDetails">
                <span class="mt-3">
                  <hr />
                  <div class="h4-text">{{ $t('Chat') }}</div>
                  <ul class="custom text-xs-left mt-3">
                    <li>
                      <a style="color: #000" href="https://tinyurl.com/3758bkbm" target="_blank">{{
                        $t('Support messaging with text/ Picture/ Carousel/ Video')
                      }}</a>
                    </li>
                    <li>
                      <a style="color: #000" href="https://tinyurl.com/3758bkbm" target="_blank">
                        {{ $t('Create comments up to')
                        }}<strong style="color: black"> 100 {{ $t('topics') }}</strong>
                      </a>
                    </li>
                    <li>
                      <a style="color: #000" href="https://tinyurl.com/3758bkbm" target="_blank">
                        {{ $t('1 topic can answer up to') }}
                        <strong style="color: black">10 {{ $t('bubbles') }}</strong>
                      </a>
                    </li>
                    <li>
                      <a style="color: #000" href="https://tinyurl.com/y5cnc2t8" target="_blank">{{
                        $t('Random answer')
                      }}</a>
                    </li>
                    <li>
                      <a style="color: #000" href="https://tinyurl.com/2vtmzeb5" target="_blank">{{
                        $t('Transfer data to another page')
                      }}</a>
                    </li>
                    <li>
                      <a style="color: #000" href="https://tinyurl.com/3pbbzz54" target="_blank">{{
                        $t('Create context messaging')
                      }}</a>
                    </li>
                    <li>
                      <a style="color: #000" href="https://tinyurl.com/2556a5py" target="_blank">{{
                        $t('Set up time to answer each topic.')
                      }}</a>
                    </li>
                    <li>
                      <a style="color: #000" href="https://tinyurl.com/5n87u5hc" target="_blank">{{
                        $t('Same messaging set up to all platforms')
                      }}</a>
                    </li>
                    <li>
                      <a style="color: #000" href="https://tinyurl.com/4jxyjr2u" target="_blank">{{
                        $t('Bot practicing function')
                      }}</a>
                    </li>
                    <li class="disable-feature">{{ $t('Reply a Sticker via LINE') }}</li>
                    <li class="disable-feature">{{ $t('Support LINE FLEX code via LINE') }}</li>
                    <li class="disable-feature">{{ $t('LINE Image Map') }}</li>
                    <li class="disable-feature">{{ $t('Follow up') }}</li>
                  </ul>
                  <div style="line-height: 0px;">&nbsp;</div>

                  <hr />
                  <div class="h4-text">{{ $t('Comment') }}</div>
                  <ul class="custom text-xs-left">
                    <li>
                      <a style="color: #000" href="https://tinyurl.com/yvz76f5s" target="_blank">
                        {{ $t('Create comments up to') }}
                        <strong style="color: black"> 100 {{ $t('topics') }}</strong></a
                      >
                    </li>
                    <li>
                      <a style="color: #000" href="https://tinyurl.com/yvz76f5s" target="_blank">{{
                        $t('Comment to Inbox0')
                      }}</a>
                    </li>
                    <li>
                      <a style="color: #000" href="https://tinyurl.com/yvz76f5s" target="_blank">
                        {{
                          $t(
                            'Comment to Inbox with text/button/ picture/ carousel/ Video and customers order summary'
                          )
                        }}
                      </a>
                    </li>
                    <li>
                      <a style="color: #000" href="https://tinyurl.com/yvz76f5s" target="_blank">{{
                        $t('Hiding Comments')
                      }}</a>
                    </li>
                    <li>
                      <a style="color: #000" href="https://tinyurl.com/3t2h9krf" target="_blank">{{
                        $t('Reply to a comment on selected posts (FB,IG)')
                      }}</a>
                    </li>
                    <li>
                      <a style="color: #000" href="https://tinyurl.com/55k48kvk" target="_blank">{{
                        $t('Random answer')
                      }}</a>
                    </li>
                    <li>
                      <a style="color: #000" href="https://tinyurl.com/2v9bnz98" target="_blank">{{
                        $t('Set up time to answer each topic.')
                      }}</a>
                    </li>
                    <li>
                      <a style="color: #000" href="https://tinyurl.com/mrxa5m58" target="_blank">{{
                        $t('Limit the number of replies to comments.')
                      }}</a>
                    </li>
                    <li class="disable-feature">{{ $t('Follow up') }}</li>
                  </ul>

                  <hr />
                  <div class="h4-text">{{ $t('Shop Service') }}</div>
                  <ul class="custom text-xs-left">
                    <li>
                      <a style="color: #000" href="https://tinyurl.com/mr3dr39k" target="_blank">
                        {{ $t('Add up to') }}
                        <strong style="color: black">500 {{ $t('products') }}</strong>
                      </a>
                    </li>
                    <li>
                      <a style="color: #000" href="https://tinyurl.com/mr3dr39k" target="_blank">{{
                        $t('Manage Stocks')
                      }}</a>
                    </li>
                    <li>
                      <a style="color: #000" href="https://tinyurl.com/mr3dr39k" target="_blank">{{
                        $t('Manage orders')
                      }}</a>
                    </li>
                    <li>
                      <a style="color: #000" href="https://tinyurl.com/mr3dr39k" target="_blank">{{
                        $t('Print the parcels cover sheet')
                      }}</a>
                    </li>
                    <li>
                      <a style="color: #000" href="https://tinyurl.com/2xa4wy8h" target="_blank">{{
                        $t('Automation Sales Summary')
                      }}</a>
                    </li>
                    <li>
                      <a style="color: #000" href="https://tinyurl.com/4trrbhje" target="_blank">{{
                        $t('In-Chat Payments')
                      }}</a>
                    </li>
                    <li>
                      <a style="color: #000" href="https://tinyurl.com/2vbz8zsy" target="_blank">{{
                        $t('generate_discount_codes_20')
                      }}</a>
                    </li>
                    <li>
                      <a style="color: #000" href="https://tinyurl.com/mr3dr39k" target="_blank">{{
                        $t('Change shops theme color')
                      }}</a>
                    </li>
                    <li>
                      <a style="color: #000" href="https://tinyurl.com/y8kv4k9h" target="_blank">{{
                        $t('Connect with Salepage')
                      }}</a>
                    </li>
                    <li>
                      <a style="color: #000" href="https://tinyurl.com/bdzkaany" target="_blank">{{
                        $t('Wholesale system')
                      }}</a>
                    </li>
                    <li>
                      <a style="color: #000" href="https://tinyurl.com/mr3dr39k" target="_blank">{{
                        $t('Sales Report')
                      }}</a>
                    </li>
                    <li>
                      <a style="color: #000" href="https://tinyurl.com/mr3dr39k" target="_blank">{{
                        $t('Export data')
                      }}</a>
                    </li>
                    <li class="disable-feature">{{ $t('Follow up') }}</li>
                  </ul>

                  <hr />
                  <div class="h4-text">{{ $t('Broadcast') }}</div>
                  <ul class="custom text-xs-left">
                    <li>
                      <a style="color: #000" href="https://tinyurl.com/yj354f7y" target="_blank">{{
                        $t('Send to customers who have interacted within 24 hours.')
                      }}</a>
                    </li>
                    <li>
                      <a style="color: #000" href="https://tinyurl.com/y27chwmw" target="_blank">
                        {{
                          $t(
                            'Send to prior customer on certain topics (according to the terms of Facebook)'
                          )
                        }}
                      </a>
                    </li>
                    <li>
                      <a style="color: #000" href="https://tinyurl.com/y27chwmw" target="_blank">
                        {{
                          $t(
                            'Broadcast with message/ message + button / picture / slide/ Video formats'
                          )
                        }}
                      </a>
                    </li>
                    <li>
                      <a style="color: #000" href="https://tinyurl.com/y27chwmw" target="_blank">{{
                        $t('Broadcast time set up')
                      }}</a>
                    </li>
                    <li>
                      <a style="color: #000" href="https://tinyurl.com/dd8x8tzc" target="_blank">{{
                        $t('Select custom audiences')
                      }}</a>
                    </li>
                    <li>
                      <a style="color: #000" href="https://tinyurl.com/3yv5542h" target="_blank">{{
                        $t('Reply up to 10 bubbles for FB/IG content.')
                      }}</a>
                    </li>
                  </ul>

                  <div style="line-height: 10px;">&nbsp;</div>

                  <hr />
                  <div class="h4-text">{{ $t('Analytics') }}</div>
                  <ul class="custom text-xs-left">
                    <li>
                      <a style="color: #000" href="https://tinyurl.com/yhfh6fd7" target="_blank">{{
                        $t('Facebook Inbox Overview')
                      }}</a>
                    </li>
                    <li>
                      <a style="color: #000" href="https://tinyurl.com/yhfh6fd7" target="_blank">{{
                        $t('Conversation/Comment Statistics')
                      }}</a>
                    </li>
                    <li>
                      <a style="color: #000" href="https://tinyurl.com/yhfh6fd7" target="_blank">{{
                        $t('User statistics')
                      }}</a>
                    </li>
                    <li>
                      <a style="color: #000" href="https://tinyurl.com/y4u5mda4" target="_blank">{{
                        $t('Tag / Status')
                      }}</a>
                    </li>
                    <li>
                      <a style="color: #000" href="https://tinyurl.com/yhfh6fd7" target="_blank">{{
                        $t('Automatically collect typed in customers email and number.')
                      }}</a>
                    </li>
                    <li>
                      <a style="color: #000" href="https://tinyurl.com/yhfh6fd7" target="_blank">{{
                        $t('Export file to Excel/CSV')
                      }}</a>
                    </li>
                    <li>
                      <a style="color: #000" href="https://tinyurl.com/mr4xb9a5" target="_blank">{{
                        $t('Import prior customers')
                      }}</a>
                    </li>
                    <li>
                      <a style="color: #000" href="https://tinyurl.com/54b6jyz4" target="_blank">{{
                        $t('Custom Audience')
                      }}</a>
                    </li>
                  </ul>
                  <hr />
                  <div class="h4-text">{{ $t('Shortcut') }}</div>
                  <ul class="custom text-xs-left">
                    <li>
                      <a style="color: #000" href="https://tinyurl.com/2p95vwnu" target="_blank">{{
                        $t('Shortcut # for switching to admin')
                      }}</a>
                    </li>
                    <li>
                      <a style="color: #000" href="https://tinyurl.com/ycnys8jd" target="_blank">{{
                        $t('Switching chatbot mode and admin mode')
                      }}</a>
                    </li>
                  </ul>
                  <hr />
                  <div class="h4-text">{{ $t('Notifications') }}</div>
                  <ul class="custom text-xs-left">
                    <li>
                      <a style="color: #000" href="https://tinyurl.com/y5gsclrb" target="_blank">
                        {{
                          $t(
                            'Connecting with LINE Notify for specific topic or chatbots unanswered question.'
                          )
                        }}
                      </a>
                    </li>
                    <li>
                      <a style="color: #000" href="https://tinyurl.com/y5gsclrb" target="_blank">
                        {{
                          $t('Connecting with LINE Notify for new orders/new payment activities.')
                        }}
                      </a>
                    </li>
                  </ul>
                  <hr />
                  <div class="h4-text">{{ $t('All-in-one Chat') }}</div>
                  <ul class="custom text-xs-left">
                    <li class="disable-feature">
                      {{ $t('Integrate FB + LINE + IG in one place') }}
                    </li>
                    <li class="disable-feature">{{ $t('Open billing via chat') }}</li>
                    <li class="disable-feature">{{ $t('Quick message function') }}</li>
                    <li class="disable-feature">{{ $t('Send and receive files') }}</li>
                    <li class="disable-feature">{{ $t('Easily switching chatbot admin mode') }}</li>
                  </ul>
                  <hr />
                  <div class="h4-text">{{ $t('Salepage') }}</div>
                  <ul class="custom text-xs-left">
                    <li>
                      <a style="color: #000" href="https://tinyurl.com/y8kv4k9h" target="_blank">{{
                        $t('Connecting with Shop Service')
                      }}</a>
                    </li>
                    <li>
                      <a style="color: #000" href="https://tinyurl.com/y8kv4k9h" target="_blank">{{
                        $t('Change Salepages theme color')
                      }}</a>
                    </li>
                    <li>
                      <a style="color: #000" href="https://tinyurl.com/y8kv4k9h" target="_blank">
                        {{ $t('Add up to') }}
                        <strong style="color: black">20 {{ $t('blocks') }}</strong>
                      </a>
                    </li>
                    <li>
                      <a style="color: #000" href="https://tinyurl.com/y8kv4k9h" target="_blank">{{
                        $t('Link to Youtube video')
                      }}</a>
                    </li>
                    <li class="disable-feature">
                      {{ $t('Provide connecting with Facebook Pixel code') }}
                    </li>
                    <li class="disable-feature">
                      {{ $t('Provide connecting with Google Tag Manager') }}
                    </li>
                    <li class="disable-feature">
                      {{ $t('Provide connecting with Google Analytics') }}
                    </li>
                    <li class="disable-feature">
                      {{ $t('Provide connecting with Tiktok Pixel') }}
                    </li>
                  </ul>
                  <hr />
                  <div class="h4-text">{{ $t('Beacon') }}</div>
                  <ul class="custom text-xs-left">
                    <li class="disable-feature">
                      {{
                        $t(
                          'This package is compatible with Beacon(a technology capable of sending messages by Bluetooth transmitters to the LINE customer app without any charge for Push Message)'
                        )
                      }}
                    </li>
                  </ul>
                  <hr />
                  <div class="h4-text">{{ $t('connect_zerva') }}</div>
                  <ul class="custom text-xs-left">
                    <li>
                      {{ $t('connecting_to_zerva') }}
                    </li>
                    <li class="disable-feature">
                      {{ $t('send_follow_up_message') }}
                    </li>
                  </ul>
                  <hr />
                  <div class="h4-text">{{ $t('messenger_ads_simulator_(json)') }}</div>
                  <ul class="custom text-xs-left">
                    <li>
                      <a style="color: #000" href="https://tinyurl.com/6jyeyub7" target="_blank">
                        {{ $t('messenger_ads_simulator_premium') }}
                      </a>
                    </li>
                  </ul>
                  <hr />
                  <div class="h4-text">{{ $t('verify_slip_title') }}</div>
                  <ul class="custom text-xs-left">
                    <li>
                      <a style="color: #000" href="https://tinyurl.com/4huutjvn" target="_blank">
                        {{ $t('verify_slip_1') }}
                      </a>
                    </li>
                    <li>
                      <a style="color: #000" href="https://tinyurl.com/4huutjvn" target="_blank">
                        {{ $t('verify_slip_2') }}
                      </a>
                    </li>
                  </ul>
                  <hr />
                  <div class="h4-text">{{ $t('connect_stocks') }}</div>
                  <ul class="custom text-xs-left">
                    <li>
                      <a style="color: #000" href="https://tinyurl.com/37yxpmjn" target="_blank">
                        {{ $t('connect_stocks_1') }}
                      </a>
                    </li>
                    <li>
                      <a
                        style="color: #000"
                        href="https://blog.zwiz.app/zortout_ordermanagement/"
                        target="_blank"
                      >
                        {{ $t('connect_stocks_2') }}
                      </a>
                    </li>
                    <li>
                      <a style="color: #000" href="https://tinyurl.com/5a3wyh2x" target="_blank">
                        {{ $t('connect_stocks_3') }}
                      </a>
                    </li>
                    <li>
                      <a style="color: #000" href="https://tinyurl.com/yr6wfw38" target="_blank">
                        {{ $t('connect_stocks_4') }}
                      </a>
                    </li>
                    <li>
                      <a style="color: #000" href="https://tinyurl.com/4tfvnhbw" target="_blank">
                        {{ $t('connect_stocks_5') }}
                      </a>
                    </li>
                    <li class="disable-feature">
                      {{ $t('connect_stocks_6') }}
                    </li>
                  </ul>
                  <hr />
                  <div class="h4-text">{{ $t('connect_shipping') }}</div>
                  <ul class="custom text-xs-left">
                    <li>
                      <a style="color: #000" href="https://tinyurl.com/taynws5p" target="_blank">
                        {{ $t('connect_shipping_1') }}
                      </a>
                    </li>
                    <li>
                      <a style="color: #000" href="https://tinyurl.com/2ft3hvjj" target="_blank">
                        {{ $t('connect_shipping_2') }}
                      </a>
                    </li>
                    <li>
                      <a style="color: #000" href="https://tinyurl.com/ykjuuny8" target="_blank">
                        {{ $t('connect_shipping_3') }}
                      </a>
                    </li>
                  </ul>
                  <div class="h4-text">{{ $t('redirect_url_tracking') }}</div>
                  <ul class="custom text-xs-left">
                    <li>
                      <a
                        style="color: #000"
                        href="https://blog.zwiz.app/redirect-url-tracking/"
                        target="_blank"
                      >
                        {{ $t('redirect_url_tracking1') }}
                      </a>
                    </li>
                  </ul>

                  <h3 class="mt-2 mb-2" style="color: black">
                    {{ $t("Number of Admins depend on Facebook's Page Role") }}
                  </h3>

                  <a @click="moreDetails = !moreDetails" style="font-weight: bold; font-size:16px">
                    {{ $t('Hide details.') }}</a
                  >
                </span>
              </template>
            </div>
          </div>
        </v-flex>
        <v-flex sm6 xs12 lg4 class="px-2 py-3">
          <div class="card-package-yellow z-border-red" style="height: 100%;">
            <img src="/static/img/assets/icon/z-15.png" alt="" />
            <h1 class="mb-0 black-color">Advanced</h1>

            <br />
            <div style="display: inline-flex;" class="mb-2">
              <v-img
                src="https://zwiz.ai/web/public/img/socials/fb.png"
                alt=""
                style="width: 34px; margin-right: 15px;"
              />
              <v-img
                src="https://zwiz.ai/web/public/img/socials/ig.jpeg"
                alt=""
                style="width: 34px; margin-right: 15px;"
              />
              <v-img
                src="https://zwiz.ai/web/public/img/socials/line.png"
                alt=""
                style="width: 34px; margin-right: 15px;"
              />
              <v-img
                src="https://zwiz.ai/web/public/img/socials/shop.png"
                alt=""
                style="width: 34px;"
              />
            </div>

            <div class="feature-card no-animate border-primary h-100">
              <div
                class="feature-card-text kanit text-xs-left  h-100"
                style="justify-content: space-between;flex-direction: column;"
              >
                <div class="mt-auto text-xs-center ">
                  <div class="packageradio text-xs-left" style="margin-top: 21px; height: 285px;">
                    <template v-for="pack in list1">
                      <div
                        style="cursor:pointer"
                        :key="pack.package"
                        class="px-3 py-2 mb-2 pack"
                        :class="{ active: pack.package == current1.package }"
                        @click="selectPack1(pack)"
                      >
                        <div class="d-inline-flex" style="font-size: 1.5rem;">
                          <div class="flex-shrink-1">
                            <i
                              class="fas"
                              :class="{
                                'fa-circle': pack.package != current1.package,
                                'fa-check-circle': pack.package == current1.package
                              }"
                              :style="{
                                color: pack.package != current1.package ? '#eee' : 'white'
                              }"
                            ></i>
                          </div>
                          <div
                            class="pl-2 black-color"
                            :style="{
                              color: pack.package != current1.package ? '' : 'white'
                            }"
                          >
                            <div class="h4 font-weight-light mb-0">
                              {{ currentLang === 'th' ? pack.text : pack.texten }}
                            </div>
                            <!-- <div
                              style="font-size: 16px;"
                              v-if="pack.dec"
                              :style="{
                                color: pack.package != current1.package ? '#ed1e79' : 'white'
                              }"
                            >
                              {{ $t('free_rich_menu') }}
                              <a
                                href="https://www.messenger.com/t/361231620965547/?ref=%E0%B8%9A%E0%B8%A3%E0%B8%B4%E0%B8%81%E0%B8%B2%E0%B8%A3%E0%B9%80%E0%B8%AA%E0%B8%A3%E0%B8%B4%E0%B8%A1%E0%B9%81%E0%B8%A5%E0%B8%B0%E0%B8%A3%E0%B8%B4%E0%B8%8A%E0%B9%80%E0%B8%A1%E0%B8%99%E0%B8%B9&messaging_source=source%3Apages%3Amessage_shortlink&source_id=1441792"
                                target="blank"
                                ><i
                                  style="font-size: 18px;"
                                  class="fas fa-question-circle"
                                  :style="{
                                    color: pack.package != current1.package ? '#ed1e79' : 'white'
                                  }"
                                ></i
                              ></a>
                            </div> -->
                            <div
                              style="font-size: 16px;"
                              :style="{
                                color: pack.package != current1.package ? 'grey' : 'white'
                              }"
                              v-if="pack.dec"
                            >
                              + {{ currentLang === 'th' ? pack.dec : pack.decen }}
                            </div>
                            <div v-if="pack.dec">
                              <a
                                style="font-size: 16px; cursor:pointer"
                                @click="dialogMoreDetail = true"
                                >{{ $t('more_details') }}</a
                              >
                            </div>
                          </div>
                        </div>
                      </div>
                    </template>

                    <h2 style="font-size: 32px;" class="primary--text">
                      {{ current1 ? `${current1.price} ${$t('Baht')}` : '' }}
                    </h2>
                  </div>
                </div>
              </div>
            </div>

            <div class="text-xs-center mb-4" style="margin-top: 60px">
              <div class="mb-3">
                <v-btn
                  style="width:100%; font-size:20px"
                  dark
                  color="primary"
                  depressed
                  @click="dialogPayment1 = true"
                >
                  <template>
                    {{ $t('Buy Advanced') }}
                  </template>
                </v-btn>
              </div>
              <a @click="moreDetails = !moreDetails" style="font-weight: bold; font-size:16px">
                {{ !moreDetails ? $t('More details') : $t('Hide details.') }}</a
              >
              <template v-if="moreDetails">
                <span class="mt-3">
                  <hr />
                  <div class="h4-text">{{ $t('Chat') }}</div>
                  <ul class="custom text-xs-left">
                    <li>
                      <a style="color: #000" href="https://tinyurl.com/3758bkbm" target="_blank">{{
                        $t('Support messaging with text/ Picture/ Carousel/ Video')
                      }}</a>
                    </li>
                    <li>
                      <a style="color: #000" href="https://tinyurl.com/3758bkbm" target="_blank">
                        {{ $t('Create comments up to') }}
                        <strong style="color: black"> 300 {{ $t('topics') }}</strong>
                      </a>
                    </li>
                    <li>
                      <a style="color: #000" href="https://tinyurl.com/3758bkbm" target="_blank">
                        {{ $t('1 topic on FB/IG bot can answer up to') }}
                        <strong style="color: black"> 10 {{ $t('bubbles') }}, </strong>
                        {{ $t('for LINE bot can answer up to') }}
                        <strong style="color: black"> 5 {{ $t('bubbles') }}</strong>
                      </a>
                    </li>
                    <li>
                      <a style="color: #000" href="https://tinyurl.com/y5cnc2t8" target="_blank">{{
                        $t('Random answer')
                      }}</a>
                    </li>
                    <li>
                      <a style="color: #000" href="https://tinyurl.com/2vtmzeb5" target="_blank">{{
                        $t('Transfer data to another page')
                      }}</a>
                    </li>
                    <li>
                      <a style="color: #000" href="https://tinyurl.com/3pbbzz54" target="_blank">{{
                        $t('Create context messaging')
                      }}</a>
                    </li>
                    <li>
                      <a style="color: #000" href="https://tinyurl.com/2556a5py" target="_blank">{{
                        $t('Set up time to reply each topic.')
                      }}</a>
                    </li>
                    <li>
                      <a style="color: #000" href="https://tinyurl.com/5n87u5hc" target="_blank">{{
                        $t('Same messaging set up to all platforms')
                      }}</a>
                    </li>
                    <li>
                      <a style="color: #000" href="https://tinyurl.com/4jxyjr2u" target="_blank">{{
                        $t('Bot practicing function')
                      }}</a>
                    </li>
                    <li>
                      <a style="color: #000" href="https://tinyurl.com/3758bkbm" target="_blank">{{
                        $t('Reply a Sticker via LINE')
                      }}</a>
                    </li>
                    <li>
                      <a style="color: #000" href="https://tinyurl.com/54xs3zku" target="_blank">{{
                        $t('Support LINE FLEX code via LINE')
                      }}</a>
                    </li>
                    <li>
                      <a style="color: #000" href="https://tinyurl.com/4rz83a52" target="_blank">{{
                        $t('LINE Image Map')
                      }}</a>
                    </li>
                    <li>
                      <a style="color: #000" href="https://tinyurl.com/5banvvcf" target="_blank">{{
                        $t('Follow up')
                      }}</a>
                    </li>
                  </ul>
                  <hr />
                  <div class="h4-text">{{ $t('Comment') }}</div>
                  <ul class="custom text-xs-left">
                    <li>
                      <a style="color: #000" href="https://tinyurl.com/yvz76f5s" target="_blank">
                        {{ $t('Create comments up to') }}
                        <strong style="color: black"> 300 {{ $t('topics') }}</strong>
                      </a>
                    </li>
                    <li>
                      <a style="color: #000" href="https://tinyurl.com/yvz76f5s" target="_blank">{{
                        $t('Comment to Inbox0')
                      }}</a>
                    </li>
                    <li>
                      <a style="color: #000" href="https://tinyurl.com/yvz76f5s" target="_blank">
                        {{
                          $t(
                            'Comment to Inbox with text/button/ picture/ carousel/ Video and customers order summary'
                          )
                        }}
                      </a>
                    </li>
                    <li>
                      <a style="color: #000" href="https://tinyurl.com/yvz76f5s" target="_blank">{{
                        $t('Hiding Comments')
                      }}</a>
                    </li>
                    <li>
                      <a style="color: #000" href="https://tinyurl.com/yvz76f5s" target="_blank">{{
                        $t('Reply to a comment on posts')
                      }}</a>
                    </li>
                    <li>
                      <a style="color: #000" href="https://tinyurl.com/3t2h9krf" target="_blank">{{
                        $t('Reply to a comment on selected posts (FB,IG)')
                      }}</a>
                    </li>
                    <li>
                      <a style="color: #000" href="https://tinyurl.com/55k48kvk" target="_blank">{{
                        $t('Random answer')
                      }}</a>
                    </li>
                    <li>
                      <a style="color: #000" href="https://tinyurl.com/2v9bnz98" target="_blank">{{
                        $t('Set up time to answer each topic.')
                      }}</a>
                    </li>
                    <li>
                      <a style="color: #000" href="https://tinyurl.com/mrxa5m58" target="_blank">{{
                        $t('Limit the number of replies to comments.')
                      }}</a>
                    </li>
                    <li>
                      <a style="color: #000" href="https://tinyurl.com/5banvvcf" target="_blank">{{
                        $t('Follow up')
                      }}</a>
                    </li>
                  </ul>
                  <hr />
                  <div class="h4-text">{{ $t('Shop Service') }}</div>
                  <ul class="custom text-xs-left">
                    <li>
                      <a style="color: #000" href="https://tinyurl.com/mr3dr39k" target="_blank">
                        {{ $t('Add up to') }}
                        <strong style="color: black">3000 {{ $t('products') }}</strong>
                      </a>
                    </li>
                    <li>
                      <a style="color: #000" href="https://tinyurl.com/mr3dr39k" target="_blank">{{
                        $t('Manage Stocks')
                      }}</a>
                    </li>
                    <li>
                      <a style="color: #000" href="https://tinyurl.com/mr3dr39k" target="_blank">{{
                        $t('Manage orders')
                      }}</a>
                    </li>
                    <li>
                      <a style="color: #000" href="https://tinyurl.com/mr3dr39k" target="_blank">{{
                        $t('Print the parcels cover sheet')
                      }}</a>
                    </li>
                    <li>
                      <a style="color: #000" href="https://tinyurl.com/2xa4wy8h" target="_blank">{{
                        $t('Automation Sales Summary')
                      }}</a>
                    </li>
                    <li>
                      <a style="color: #000" href="https://tinyurl.com/4trrbhje" target="_blank">{{
                        $t('In-Chat Payments')
                      }}</a>
                    </li>
                    <li>
                      <a style="color: #000" href="https://tinyurl.com/2vbz8zsy" target="_blank">{{
                        $t('generate_discount_codes_50')
                      }}</a>
                    </li>
                    <li>
                      <a style="color: #000" href="https://tinyurl.com/mr3dr39k" target="_blank">{{
                        $t('Change shops theme color')
                      }}</a>
                    </li>
                    <li>
                      <a style="color: #000" href="https://tinyurl.com/y8kv4k9h" target="_blank">{{
                        $t('Connect with Salepage')
                      }}</a>
                    </li>
                    <li>
                      <a style="color: #000" href="https://tinyurl.com/bdzkaany" target="_blank">{{
                        $t('Wholesale system')
                      }}</a>
                    </li>
                    <li>
                      <a style="color: #000" href="https://tinyurl.com/mr3dr39k" target="_blank">{{
                        $t('Sales Report')
                      }}</a>
                    </li>
                    <li>
                      <a style="color: #000" href="https://tinyurl.com/mr3dr39k" target="_blank">{{
                        $t('Export data')
                      }}</a>
                    </li>
                    <li>
                      <a style="color: #000" href="https://tinyurl.com/5banvvcf" target="_blank">{{
                        $t('Follow up')
                      }}</a>
                    </li>
                  </ul>
                  <hr />
                  <div class="h4-text">{{ $t('Broadcast') }}</div>
                  <ul class="custom text-xs-left">
                    <li>
                      <a style="color: #000" href="https://tinyurl.com/yj354f7y" target="_blank">{{
                        $t('Send to customers who have interacted within 24 hours.')
                      }}</a>
                    </li>
                    <li>
                      <a style="color: #000" href="https://tinyurl.com/y27chwmw" target="_blank">
                        {{
                          $t(
                            'Send to prior customer on certain topics (according to the terms of Facebook)'
                          )
                        }}
                      </a>
                    </li>
                    <li>
                      <a style="color: #000" href="https://tinyurl.com/y27chwmw" target="_blank">
                        {{
                          $t(
                            'Broadcast with message/ message + button / picture / slide/ Video formats'
                          )
                        }}
                      </a>
                    </li>
                    <li>
                      <a style="color: #000" href="https://tinyurl.com/y27chwmw" target="_blank">{{
                        $t('Broadcast time set up')
                      }}</a>
                    </li>
                    <li>
                      <a style="color: #000" href="https://tinyurl.com/dd8x8tzc" target="_blank">{{
                        $t('Select custom audiences')
                      }}</a>
                    </li>
                    <li>
                      <a style="color: #000" href="https://tinyurl.com/3yv5542h" target="_blank">
                        {{ $t('For FB/IG reply up to') }}
                        <strong style="color: black">10 {{ $t('bubbles') }}</strong>
                        {{ $t('for LINE reply up to') }}
                        <strong style="color: black">5 {{ $t('bubbles') }}</strong>
                      </a>
                    </li>
                  </ul>
                  <hr />
                  <div class="h4-text">{{ $t('Analytics') }}</div>
                  <ul class="custom text-xs-left">
                    <li>
                      <a style="color: #000" href="https://tinyurl.com/yhfh6fd7" target="_blank">{{
                        $t('Facebook Inbox Overview')
                      }}</a>
                    </li>
                    <li>
                      <a style="color: #000" href="https://tinyurl.com/yhfh6fd7" target="_blank">{{
                        $t('Conversation/Comment Statistics')
                      }}</a>
                    </li>
                    <li>
                      <a style="color: #000" href="https://tinyurl.com/yhfh6fd7" target="_blank">{{
                        $t('User statistics')
                      }}</a>
                    </li>
                    <li>
                      <a style="color: #000" href="https://tinyurl.com/2rs9ahu7" target="_blank">{{
                        $t('Tag / status')
                      }}</a>
                    </li>
                    <li>
                      <a style="color: #000" href="https://tinyurl.com/yhfh6fd7" target="_blank">{{
                        $t('Automatically collect typed in customers email and number.')
                      }}</a>
                    </li>
                    <li>
                      <a style="color: #000" href="https://tinyurl.com/yhfh6fd7" target="_blank">{{
                        $t('Export file to Excel/CSV')
                      }}</a>
                    </li>
                    <li>
                      <a style="color: #000" href="https://tinyurl.com/mr4xb9a5" target="_blank">{{
                        $t('Import prior customers')
                      }}</a>
                    </li>
                    <li>
                      <a style="color: #000" href="https://tinyurl.com/54b6jyz4" target="_blank">{{
                        $t('Custom Audience')
                      }}</a>
                    </li>
                  </ul>
                  <hr />
                  <div class="h4-text">{{ $t('Shortcut') }}</div>
                  <ul class="custom text-xs-left">
                    <li>
                      <a style="color: #000" href="https://tinyurl.com/2p95vwnu" target="_blank">{{
                        $t('Shortcut # for switching to admin')
                      }}</a>
                    </li>
                    <li>
                      <a style="color: #000" href="https://tinyurl.com/ycnys8jd" target="_blank">{{
                        $t('Switching chatbot mode and admin mode')
                      }}</a>
                    </li>
                  </ul>
                  <hr />
                  <div class="h4-text">{{ $t('Notifications') }}</div>
                  <ul class="custom text-xs-left">
                    <li>
                      <a style="color: #000" href="https://tinyurl.com/y5gsclrb" target="_blank">
                        {{
                          $t(
                            'Connecting with LINE Notify for specific topic or chatbots unanswered question.'
                          )
                        }}
                      </a>
                    </li>
                    <li>
                      <a style="color: #000" href="https://tinyurl.com/y5gsclrb" target="_blank">
                        {{
                          $t('Connecting with LINE Notify for new orders/new payment activities.')
                        }}
                      </a>
                    </li>
                  </ul>
                  <hr />
                  <div class="h4-text">{{ $t('All-in-one Chat') }}</div>
                  <ul class="custom text-xs-left">
                    <li>
                      <a style="color: #000" href="https://tinyurl.com/22tprpt3" target="_blank">{{
                        $t('Integrate FB + LINE + IG in one place')
                      }}</a>
                    </li>
                    <li>
                      <a style="color: #000" href="https://tinyurl.com/4jv2pn3c" target="_blank">{{
                        $t('Open billing via chat')
                      }}</a>
                    </li>
                    <li>
                      <a style="color: #000" href="https://tinyurl.com/22tprpt3" target="_blank">{{
                        $t('Quick message function')
                      }}</a>
                    </li>
                    <li>
                      <a style="color: #000" href="https://tinyurl.com/22tprpt3" target="_blank">{{
                        $t('Send and receive files')
                      }}</a>
                    </li>
                    <li>
                      <a style="color: #000" href="https://tinyurl.com/22tprpt3" target="_blank">{{
                        $t('Easily switching chatbot admin mode')
                      }}</a>
                    </li>
                  </ul>
                  <hr />
                  <div class="h4-text">{{ $t('Salepage') }}</div>
                  <ul class="custom text-xs-left">
                    <li>
                      <a style="color: #000" href="https://tinyurl.com/y8kv4k9h" target="_blank">{{
                        $t('Connecting with Shop Service')
                      }}</a>
                    </li>
                    <li>
                      <a style="color: #000" href="https://tinyurl.com/y8kv4k9h" target="_blank">{{
                        $t('Change Salepages theme color')
                      }}</a>
                    </li>
                    <li>
                      <a style="color: #000" href="https://tinyurl.com/y8kv4k9h" target="_blank">
                        {{ $t('Add up to') }}
                        <strong style="color: black">20 {{ $t('blocks') }}</strong>
                      </a>
                    </li>
                    <li>
                      <a style="color: #000" href="https://tinyurl.com/y8kv4k9h" target="_blank">{{
                        $t('Link to Youtube video')
                      }}</a>
                    </li>
                    <li>
                      <a style="color: #000" href="https://tinyurl.com/5fvda64n" target="_blank">{{
                        $t('Provide connecting with Facebook Pixel code')
                      }}</a>
                    </li>
                    <li>
                      <a style="color: #000" href="https://tinyurl.com/5fvda64n" target="_blank">{{
                        $t('Provide connecting with Google Tag Manager')
                      }}</a>
                    </li>
                    <li>
                      <a style="color: #000" href="https://tinyurl.com/5fvda64n" target="_blank">{{
                        $t('Provide connecting with Google Analytics')
                      }}</a>
                    </li>
                    <li>
                      <a style="color: #000" href="https://tinyurl.com/5fvda64n" target="_blank">{{
                        $t('Provide connecting with Tiktok Pixel')
                      }}</a>
                    </li>
                  </ul>
                  <hr />
                  <div class="h4-text">{{ $t('Beacon') }}</div>
                  <ul class="custom text-xs-left">
                    <li>
                      <a style="color: #000" href="https://tinyurl.com/4a32wy36" target="_blank">
                        {{
                          $t(
                            'This package is compatible with Beacon(a technology capable of sending messages by Bluetooth transmitters to the LINE customer app without any charge for Push Message)'
                          )
                        }}
                      </a>
                    </li>
                  </ul>
                  <hr />
                  <div class="h4-text">{{ $t('connect_zerva') }}</div>
                  <ul class="custom text-xs-left">
                    <li>
                      {{ $t('connecting_to_zerva') }}
                    </li>
                    <li>
                      {{ $t('send_follow_up_message') }}
                    </li>
                  </ul>
                  <hr />
                  <div class="h4-text">{{ $t('messenger_ads_simulator_(json)') }}</div>
                  <ul class="custom text-xs-left">
                    <li>
                      <a style="color: #000" href="https://tinyurl.com/6jyeyub7" target="_blank">
                        {{ $t('messenger_ads_simulator_advanced') }}
                      </a>
                    </li>
                  </ul>
                  <hr />
                  <div class="h4-text">{{ $t('verify_slip_title') }}</div>
                  <ul class="custom text-xs-left">
                    <li>
                      <a style="color: #000" href="https://tinyurl.com/4huutjvn" target="_blank">
                        {{ $t('verify_slip_1') }}
                      </a>
                    </li>
                    <li>
                      <a style="color: #000" href="https://tinyurl.com/4huutjvn" target="_blank">
                        {{ $t('verify_slip_2') }}
                      </a>
                    </li>
                  </ul>
                  <hr />
                  <div class="h4-text">{{ $t('connect_stocks') }}</div>
                  <ul class="custom text-xs-left">
                    <li>
                      <a style="color: #000" href="https://tinyurl.com/37yxpmjn" target="_blank">
                        {{ $t('connect_stocks_1') }}
                      </a>
                    </li>
                    <li>
                      <a
                        style="color: #000"
                        href="https://blog.zwiz.app/zortout_ordermanagement/"
                        target="_blank"
                      >
                        {{ $t('connect_stocks_2') }}
                      </a>
                    </li>
                    <li>
                      <a style="color: #000" href="https://tinyurl.com/5a3wyh2x" target="_blank">
                        {{ $t('connect_stocks_3') }}
                      </a>
                    </li>
                    <li>
                      <a style="color: #000" href="https://tinyurl.com/yr6wfw38" target="_blank">
                        {{ $t('connect_stocks_4') }}
                      </a>
                    </li>
                    <li>
                      <a style="color: #000" href="https://tinyurl.com/4tfvnhbw" target="_blank">
                        {{ $t('connect_stocks_5') }}
                      </a>
                    </li>
                    <li>
                      <a
                        style="color: #000"
                        href="https://blog.zwiz.app/lineshopping/"
                        target="_blank"
                      >
                        {{ $t('connect_stocks_6') }}
                      </a>
                    </li>
                  </ul>
                  <hr />
                  <div class="h4-text">{{ $t('connect_shipping') }}</div>
                  <ul class="custom text-xs-left">
                    <li>
                      <a style="color: #000" href="https://tinyurl.com/taynws5p" target="_blank">
                        {{ $t('connect_shipping_1') }}
                      </a>
                    </li>
                    <li>
                      <a style="color: #000" href="https://tinyurl.com/2ft3hvjj" target="_blank">
                        {{ $t('connect_shipping_2') }}
                      </a>
                    </li>
                    <li>
                      <a style="color: #000" href="https://tinyurl.com/ykjuuny8" target="_blank">
                        {{ $t('connect_shipping_3') }}
                      </a>
                    </li>
                  </ul>
                  <div class="h4-text">{{ $t('redirect_url_tracking') }}</div>
                  <ul class="custom text-xs-left">
                    <li>
                      <a
                        style="color: #000"
                        href="https://blog.zwiz.app/redirect-url-tracking/"
                        target="_blank"
                      >
                        {{ $t('redirect_url_tracking1') }}
                      </a>
                    </li>
                  </ul>

                  <h3 class="mt-2 mb-2" style="color: black">
                    {{ $t("Number of Admins depend on Facebook's Page Role / LINE's Permission") }}
                  </h3>

                  <a @click="moreDetails = !moreDetails" style="font-weight: bold; font-size:16px">
                    {{ $t('Hide details.') }}</a
                  >
                </span>
              </template>
            </div>
          </div>
        </v-flex>
      </v-layout>
      <div v-else>
        <div class="card-package z-border text-xs-center">
          <h5 v-if="$store.getters.getPackage != 'premium'">ຖ້າຢາກໃຊ້ແພັກເກດລາວແຊັດບອ໋ດ</h5>
          <h5 v-else>ຖ້າທ່ານສົງໃສ ຫລືມີຄວາມຕ້ອງການອື່ນໆ</h5>
          <a href="https://www.facebook.com/coach4mkt/" target="_blank">
            <v-btn depressed color="primary">ຕິດຕໍ່ພວກເຮົາ</v-btn>
          </a>
        </div>
      </div>
      <v-layout>
        <v-flex sm12 xs12 lg12>
          <div class="card-package-yellow z-border-red" style="height: 100%;">
            <div>
              <h1 style="font-size: 2rem;">Business Package</h1>
              <h3 class="font-weight-light" style="color: #000">
                {{ $t('business_package_detail') }}
              </h3>
            </div>
            <div class="feature-card no-animate border-primary">
              <div
                class="feature-card-text kanit text-xs-left"
                style="justify-content: space-between;flex-direction: column;"
              >
                <div class="mt-auto text-xs-center ">
                  <div class="packageradio text-xs-left" style="margin-top: 21px;">
                    <div style="cursor:pointer" class="px-3 py-2 mb-2 pack active">
                      <div class="d-inline-flex" style="font-size: 1.5rem;">
                        <div class="flex-shrink-1">
                          <i class="fas fa-check-circle" style="color: white"></i>
                        </div>
                        <div class="pl-2 black-color" style="color: white">
                          <div>
                            {{ $t('1_year') }}
                          </div>
                          <span style="font-size: 16px;">+ {{ $t('service_and_privately') }}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <h1 class="primary--text text-xs-left mt-2 mb-2">
                    {{ $t('price_business_pack') }}
                  </h1>
                  <a
                    style="font-weight: bold; font-size:16px"
                    @click="moreDetailsBusiness = !moreDetailsBusiness"
                    >{{ $t('More details') }}</a
                  >
                  <div>
                    <v-btn
                      class="mt-4"
                      style="width:50%; font-size:20px"
                      dark
                      color="primary"
                      depressed
                      @click="contactUs"
                    >
                      <template>
                        {{ $t('contact_us') }}
                      </template>
                    </v-btn>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </v-flex>
      </v-layout>
      <template v-if="false">
        <div>
          <div style="margin: 35px 0px;">
            <h3 class="text-xs-center title">Add-on Line Chatbot Package</h3>
          </div>
          <div class="row">
            <div class="col-xs-12 col-sm-6 col-md-4 text-xs-center">
              <div class="card-package">
                <strong>Basic Package</strong>
                <hr />
                <h3 class="title">+1,498 Baht / Month</h3>

                <hr />
                <p>1 Basic Line@ Account</p>
                <hr />
                <p>1 Line Chatbot</p>
                <hr />

                <a :href="'mailto:' + $store.state.theme.email_contact" class="btn btn-select-plan"
                  >Contact Us</a
                >
              </div>
            </div>
            <div class="col-xs-12 col-sm-6 col-md-4 text-xs-center">
              <div class="card-package">
                <strong>Pro Package</strong>
                <hr />
                <h3 class="title">+2,498 Baht / Month</h3>

                <hr />
                <p>1 Pro Line@ Account</p>
                <hr />
                <p>1 Line Chatbot</p>
                <hr />

                <!-- <p style="color:red">Save Price 1,000 baht</p> -->
                <a :href="'mailto:' + $store.state.theme.email_contact" class="btn btn-select-plan"
                  >Contact Us</a
                >
              </div>
            </div>
            <div class="col-xs-12 col-sm-6 col-md-4 text-xs-center">
              <div class="card-package">
                <strong>Pro+ Package</strong>
                <hr />
                <h3 class="title">+7,388 Baht / Month</h3>

                <hr />
                <p>1 Pro+ Line@ Account</p>
                <hr />
                <p>1 Line Chatbot</p>
                <hr />

                <!-- <p style="color:red">Save Price 1,000 baht</p> -->
                <a :href="'mailto:' + $store.state.theme.email_contact" class="btn btn-select-plan"
                  >Contact Us</a
                >
              </div>
            </div>
          </div>
        </div>
      </template>

      <modal-dialog @close="showSuccess = false" v-if="showSuccess">
        <div slot="body" class="text-xs-center" style="margin-top: 45px;">
          <img src="/static/img/assets/shop/success_mark.png" alt style="width: 150px;" />
          <h5>Payment Successful</h5>
        </div>

        <div slot="footer" class="text-xs-center" style="padding: 10px">
          <a href="javascript:void(0)" class="btn btn-primary" @click="showSuccess = false"
            >Close</a
          >
        </div>
      </modal-dialog>

      <modal-dialog @close="showFail = false" v-if="showFail">
        <div slot="body" class="text-xs-center" style="margin-top: 45px;">
          <img src="/static/img/assets/shop/fail_mark.png" alt style="width: 150px;" />
          <h1>Payment Unsuccessful</h1>
          <p class="small">{{ errorMessage }}</p>
        </div>

        <div slot="footer" class="text-xs-center" style="padding: 10px">
          <a href="javascript:void(0)" class="btn btn-primary" @click="showFail = false">Close</a>
        </div>
      </modal-dialog>
    </div>
    <template v-if="false">
      <div v-if="!selectedBot.packages.includes('line')"></div>
      <div v-else>
        <div class="text-xs-center" style="margin-top: 35px;">
          <p>
            Please contact email
            <a :href="'mailto:' + $store.state.theme.email_contact">{{
              $store.state.theme.email_contact
            }}</a>
            for more information.
          </p>
        </div>
      </div>
    </template>
    <v-dialog v-if="dialogPayment" persistent v-model="dialogPayment" width="500">
      <v-card class="text-xs-center">
        <div style="position: absolute; right: 5px;">
          <v-btn fab small flat @click="dialogPayment = false">
            <v-icon>close</v-icon>
          </v-btn>
        </div>
        {{ current.packag }}
        <div v-if="dialogPayment1" :ref="current.package" :id="current.package"></div>
        <template v-if="loading">
          <v-card-text>
            <div class=" text-xs-center">
              <v-progress-circular indeterminate color="primary"></v-progress-circular>
            </div>
          </v-card-text>
        </template>
        <template v-else>
          <v-card-text>
            <h3>{{ $t('Get / Continue Premium') }}</h3>
            <premium-form
              color="primary"
              :params="current.package"
              :type="'qrcode'"
              :pid="current.pid"
              :key="current.pid"
              :pack="current.name"
            ></premium-form>
            <div v-if="dialogPayment" class="caption" style="margin-top: .5em">{{ $t('or') }}</div>
            <premium-form
              color="primary"
              :params="current.package"
              :type="'gbprime'"
              :pack="current.name"
              :pid="current.pid"
            ></premium-form>
          </v-card-text>
        </template>
        <v-divider></v-divider>
      </v-card>
    </v-dialog>
    <v-dialog persistent v-if="dialogPayment1" v-model="dialogPayment1" width="500">
      <v-card class="text-xs-center">
        <div style="position: absolute; right: 5px;">
          <v-btn fab small flat @click="dialogPayment1 = false">
            <v-icon>close</v-icon>
          </v-btn>
        </div>
        <div v-if="dialogPayment" :ref="current1.package" :id="current1.package"></div>
        <template v-if="loading">
          <v-card-text>
            <div class=" text-xs-center">
              <v-progress-circular indeterminate color="primary"></v-progress-circular>
            </div>
          </v-card-text>
        </template>
        <template v-else>
          <v-card-text>
            <h3>{{ $t('Get / Continue Advanced') }}</h3>
            <premium-form
              color="primary"
              :params="current1.package"
              :type="'advancedQrcode'"
              :pid="current1.pid"
              :pack="current1.name"
            ></premium-form>
            <div class="caption" style="margin-top: .5em">{{ $t('or') }}</div>
            <premium-form
              color="primary"
              :params="current1.package"
              :type="'advancedGbprime'"
              :pack="current1.name"
              :pid="current1.pid"
            ></premium-form>
          </v-card-text>
        </template>
        <v-divider></v-divider>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogMoreDetail" width="500">
      <v-card>
        <v-card-text>
          <v-layout wrap>
            <v-flex style="align-self: center;">
              <h2>{{ $t('pricing_dialog') }}</h2>
            </v-flex>
            <v-flex class="text-xs-right">
              <v-btn flat icon small fab @click="dialogMoreDetail = false">
                <v-icon>close</v-icon>
              </v-btn>
            </v-flex>
          </v-layout>
          <div>
            <strong>{{ $t('pricing_dialog2') }}</strong> {{ $t('pricing_dialog3') }}
            <ul class="mt-3">
              <li>{{ $t('pricing_dialog4') }}</li>
              <li>{{ $t('pricing_dialog5') }}</li>
              <li>{{ $t('pricing_dialog6') }}</li>
              <li>{{ $t('pricing_dialog7') }}</li>
            </ul>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog v-model="moreDetailsBusiness" width="500">
      <v-card>
        <v-card-text>
          <v-layout wrap>
            <v-flex style="align-self: center;">
              <h2>{{ $t('pricing_dialog') }}</h2>
            </v-flex>
            <v-flex class="text-xs-right">
              <v-btn flat icon small fab @click="moreDetailsBusiness = false">
                <v-icon>close</v-icon>
              </v-btn>
            </v-flex>
          </v-layout>
          <div>
            <ul class="mt-3">
              <li class="mb-1">- {{ $t('more_details_business1') }}</li>
              <li class="mb-1">- {{ $t('more_details_business2') }}</li>
              <li class="mb-1">- {{ $t('more_details_business3') }}</li>
              <li class="mb-1">- {{ $t('more_details_business4') }}</li>
              <li class="mb-1">- {{ $t('more_details_business5') }}</li>
              <li class="mb-1">- {{ $t('more_details_business6') }}</li>
              <li class="mb-1">- {{ $t('more_details_business7') }}</li>
            </ul>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'
import ModalDialog from '@/components/elements/ModalDialog'
import { setInterval, clearInterval } from 'timers'
import premiumForm from '@/components/elements/premiumForm.vue'
import api from '@/api'

export default {
  data: function() {
    return {
      moreDetailsBusiness: false,
      dialogMoreDetail: false,
      moreDetails: false,
      dialogPayment: false,
      dialogPayment1: false,
      state: 'premium',
      environment: 'production',
      showSuccess: false,
      showFail: false,
      errorMessage: '',
      paypal_actions: undefined,
      dialog: false,
      lineid: '',
      loading: true,
      list: [
        {
          name: '3 Months 1,500 Baht',
          id: '3_month',
          text: '3 เดือน',
          texten: '3 months',
          price: '1,500',
          dec: '',
          package: 'btn_3month_fb',
          pid: '8521'
        },
        {
          name: '1 Year 4,999 Baht',
          id: '1_year',
          text: '1 ปี (365 วัน)',
          texten: '1 year (365 days)',
          price: '4,999',
          dec: '',
          package: 'btn_12month_fb',
          pid: '8519'
        },
        {
          name: '1 Year Extra 7,999 Baht',
          id: '1_year_extra',
          text: '1 ปี (365 วัน)',
          texten: '1 year (365 days)',
          price: '7,999',
          dec: 'บริการรับตั้งค่า และสอนส่วนตัวให้',
          decen: 'Set up service and teach privately.',
          package: 'btn_12month_extra_fb',
          pid: '12233',
          icon: '/static/img/assets/icon/z-16.png'
        }
      ],
      list1: [
        // {
        //   name: '1 Months 1 Baht',
        //   id: '1_month',
        //   text: '1 เดือน',
        //   texten: '1 months',
        //   price: '1',
        //   dec: '',
        //   package: 'test_1month_advanced_fb',
        //   pid: '0'
        // },
        {
          name: '3 Months 2,970 Baht',
          id: '3_month',
          text: '3 เดือน',
          texten: '3 months',
          price: '2,970',
          dec: '',
          package: 'advanced_3month_fb',
          pid: '181011'
        },
        {
          name: '1 Years 8,999 Baht',
          id: '1_year',
          text: '1 ปี (365 วัน)',
          texten: '1 year (365 days)',
          price: '8,999',
          dec: '',
          package: 'advanced_12month_fb',
          pid: '181014'
        },
        {
          name: '1 Years Extra 11,999 Baht',
          id: '1_year_extra',
          text: '1 ปี (365 วัน)',
          texten: '1 year (365 days)',
          price: '11,999',
          dec: 'บริการรับตั้งค่า และสอนส่วนตัวให้',
          decen: 'Set up service and teach privately.',
          package: 'advanced_12month_extra_fb',
          pid: '181015',
          icon: '/static/img/assets/icon/z-16.png'
        }
      ],
      current: {
        name: '3 Months 1,500 Baht',
        id: '3_month',
        text: '3 เดือน',
        texten: '3 months',
        price: '1,500',
        dec: '',
        package: 'btn_3month_fb',
        pid: '8521'
      },
      current1: {
        name: '3 Months 2,970 Baht',
        id: '3_month',
        text: '3 เดือน',
        texten: '3 months',
        price: '2,970',
        dec: '',
        package: 'advanced_3month_fb',
        pid: '181011'
      }
    }
  },
  components: {
    ModalDialog,
    premiumForm
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot',
      botlist: 'botlist',
      currentLang: 'currentLang'
    })
  },
  mounted: function() {
    const vm = this
    if (
      (vm.getPackageType().includes('premium') || vm.getPackageType().includes('old_premium')) &&
      vm.getPackageType().includes('advanced')
    ) {
      vm.state = 'advanced'
    } else if (
      vm.getPackageType().includes('premium') ||
      vm.getPackageType().includes('old_premium')
    ) {
      vm.state = 'premium'
    } else {
      vm.state = 'advanced'
    }
    vm.loading = false
  },
  methods: {
    contactUs() {
      window.open('https://m.me/zwizai?ref=buyingplatinumservice', '_blank')
    },
    selectPack1(pack1) {
      if (this.current1 == pack1) {
        this.current1 = null
      } else {
        this.current1 = pack1
        this.current_modal1 = pack1.package
      }
    },
    selectPack(pack) {
      if (this.current == pack) {
        this.current = null
      } else {
        this.current = pack
        this.current_modal = pack.package
      }
    },
    handleClickPremium() {
      if (this.selectedBot.packages.includes('line')) {
        this.$swal({
          title: this.$t('Warning!'),
          text: this.$t(
            'Warning: Premium Package is not supported LINE OA. If you connected to LINE OA, please upgrade to Advanced Package'
          ),
          confirmButtonText: this.$t('Proceed'),
          cancelButtonText: this.$t('cancel'),
          showCancelButton: true
        }).then(result => {
          if (result.value) {
            setTimeout(() => {
              this.dialogPayment = true
            }, 200)
          }
        })
      } else {
        this.dialogPayment = true
      }
    },
    contactAdmin(url) {
      window.open(url, '_blank')
    },
    confirm() {
      let vm = this
      vm.$validator.validate().then(result => {
        if (!result) {
          // do stuff if not valid.
          vm.goToErrorInput()
          return false
        }
        let data = { pageid: vm.selectedBot.pageid, lineid: vm.lineid }
        api.collectlineidpremiumextra(data, (error, response) => {
          if (error) console.error(error)
          alert('success')
        })
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.packageradio {
  .pack {
    border: 1px solid #eee;
    border-radius: 20px;
    border-bottom-right-radius: 0;

    &.active {
      background: rgb(237, 30, 121);
      background: linear-gradient(180deg, rgba(237, 30, 121, 1) 0%, rgba(192, 0, 94, 1) 100%);
      border: 1px solid rgb(237, 30, 121);
      box-shadow: #f2119726 0px 6px 8px 1px;
    }
  }
}
.black-color {
  color: #000;
}

.custom {
  padding: 0px 9%;
  margin-bottom: 2rem;
  font-size: 16px;
  font-weight: 400;
  line-height: 1.6;
  color: #212529;
  li {
    list-style: none;
  }
  li::before {
    content: '';
    display: inline-block;
    height: 13px;
    width: 13px;
    background-image: url('/static/img/assets/shop/bullet1.png');
    background-size: cover;

    margin-left: -18px;
    margin-right: 5px;
  }
  li.disable::before,
  li.disable-feature::before {
    background-image: url('/static/img/assets/shop/bullet1-disable.png');
    opacity: 0.2;
  }
}
.disable-feature {
  color: #eee;
  text-decoration: line-through;
}
.h4-text {
  color: #000;
  font-size: 1.5rem;
  margin-bottom: 1rem;
  margin-top: 1rem;
  font-weight: 500;
  line-height: 1.2;
}
a:active,
a:hover {
  text-decoration-line: underline;
}
</style>



// WEBPACK FOOTER //
// src/components/view/setting/ViewPackage.vue